const themeConfig = {
	palette: {
		body: {
			main: "#ffffff",
			light: "#f5f5f5",
			dark: "#e0e0e0",
			contrastText: "#000000",
		},
		appBar: {
			public: {
				main: "#2c0065",
				light: "#2c0065",
				dark: "#2c0065",
				contrastText: "#ffffff",
				gradient: "linear-gradient(90deg, #2c0065, #622c6d)",
			},
		},
		titleBar: {
			public: {
				main: "#2c0065",
				light: "#2c0065",
				dark: "#2c0065",
				contrastText: "#ffffff",
				gradient: `url('/texture.png'), linear-gradient(90deg, #502970 30%, #7a1988)`,
			},
		},
		primary: {
			main: "#2c0065",
			light: "#2c0065",
			dark: "#2c0065",
			contrastText: "#ffffff",
		},
		secondary: {
			main: "#1c60ce",
			light: "#1c60ce",
			dark: "#1c60ce",
			contrastText: "#ffffff",
		},
		footer: {
			light: "#434f5c",
			main: "#333d47",
			dark: "#212930",
			contrastText: "#ffffff",
      link: "#C3C5C8",
      linkHover: "#FFFFFF"
		},
    subnav: {
		  main: "#f9fbfd",
		  contrastText: "#6d7781",
      light: "#E8E8E8",
	  },
		link: {
			main: "#0472b0",
			light: "#016197",
			dark: "#00466e",
		},
    buttonLink: {
			main: "#0472b0",
			light: "#016197",
			dark: "#00466e",
		},
		excerptLink: {
			main: "#000000",
			light: "#000000",
			dark: "#000000",
		},
		tab: {
			main: "#37236a",
			light: "#473080",
			contrastText: "#ffffff",
		},
	},
	typography: {
		fontFamily: [
			"Open Sans",
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		fontWeightBold: 600,
		subtitle2: {
			fontFamily: "Open Sans",
			fontWeight: 600,
			opacity: 1,
			color: "#000000",
		},
		body1: {
			fontSize: "1em",
		},
		body2: {
			opacity: 1,
		},
		h1: {
			fontFamily: "Open Sans",
			fontWeight: 400,
			fontSize: "2rem",
		},
		h2: {
			fontFamily: "Open Sans",
			fontWeight: 600,
			fontSize: "1.8rem",
		},
		h3: {
			fontFamily: "Open Sans",
			fontWeight: 400,
			fontSize: "1.6rem",
		},
		h4: {
			fontFamily: "Open Sans",
			fontWeight: 400,
			fontSize: "1.4rem",
		},
		h5: {
			fontFamily: "Open Sans",
			fontWeight: 600,
			fontSize: "1.2rem",
		},
		h6: {
			fontFamily: "Open Sans",
			fontWeight: 600,
			fontSize: "1rem",
		},
    nav: {
      fontFamily: "Open Sans",
			fontWeight: 600,
      textTransform: "uppercase",
      fontSize: "0.8rem",
		},
    subnav: {
			textTransform: "none",
		},
		brandTitle: {
			fontFamily: "Open Sans",
			fontWeight: 600,
		},
		titleBar: {
			fontFamily: "Open Sans",
		},
		subtitle1: {
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: 1.5,
			letterSpacing: "-0.01562em",
			fontSize: "1.3rem",
		},
	},
	cloverleaf: {
		googleFont: "Open+Sans:ital,wght@0,400;0,600;1,400;1,600",
    navbar: {
      align: "right",
      padding: 2,
      spacing: 3,
      borderRadius: 9,
      gap: 1.5
    },
		sidebar: {
      style: "box",
      underline: "#B8A57A",
		},
		brand: {
			size: 96,
      paddingTop: 2.5,
      paddingBottom: 2.5,
      logoFooterSize: 75
		},
		list: {
			calendarDefault: true,
      underline: "#ffc700",
      underlineStyle: "rounded",
		},
    tab: {
      fontSize: "1.2rem",
    },
		newsletter: {
			action:
				"https://occupationaltherapy.us10.list-manage.com/subscribe/post?u=d85d8027786ed7aefa1b3c067&amp;id=da1f46bda6&amp;f_id=00d8a5e5f0",
			fieldName: "EMAIL",
			title: "Sign up for our newsletter",
			narrow: true,
		},
		footer: {
			maxCols: 5,
		},
		single: {
			style: "flush",
      padding: 0.001,
      spacing: 4
		},
		css: `
      #___gatsby .MuiAppBar-root {
        border-bottom: 2px solid #ffc700 !important;
      }
      #___gatsby .desktop-nav {
        position: relative;
      }
      #___gatsby .desktop-nav::before {
        content: " ";
        position: absolute;
        top: 1rem;
        left: 0;
        width: 100%;
        height: 1px;
        background-image: -webkit-gradient(linear, left top, right top, color-stop(28%, rgba(255, 255, 255, 0.01)), to(rgba(255, 255, 255, 0.21)));
        background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.01) 28%, rgba(255, 255, 255, 0.21));
        z-index: 1;
      }
      #___gatsby .text blockquote {
        background-color: #f1f6fb;
        border-left-color: #e9eff5;
      }
    `,
	},
};
module.exports = themeConfig;
